<template>
  <div class="sidebar-bg">
    <div v-for="twoDepthMenu in sideMenuList"
         class="two-depth-menu">
      <i v-show="twoDepthMenu
          .lowerMenuList
          .map(elm=>isHighlight(elm.url))
          .some(elm=>elm===true)"
        class="ico_oval_6"></i>{{twoDepthMenu.name}}
      <div v-for="threeDepthMenu in twoDepthMenu.lowerMenuList" class="mt-1">
        <router-link class="three-depth-menu" :to="threeDepthMenu.url" :highlight="isHighlight(threeDepthMenu.url)">
          {{threeDepthMenu.name}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "DefaultSideMenu",
    data() {
      return {}
    },
    mounted() {

    },
    computed: {
      ...mapGetters(['getMenus']),
      sideMenuList() {
        const menus = this.getMenus;
        const path = this.$route.path;
        const menuPath = this.$route.meta.menuPath;

        let foundMenu = null;

        for (const oneDepthMenu of menus) {
          for (const twoDepthMenu of oneDepthMenu.lowerMenuList) {
            for (const threeDepthMenu of twoDepthMenu.lowerMenuList) {
              if (threeDepthMenu.url === path ||
                  (menuPath && threeDepthMenu.url === menuPath)) {
                foundMenu = oneDepthMenu;
              }
            }
          }
        }

        return foundMenu ? foundMenu.lowerMenuList : [];
      }
    },
    methods: {
      isHighlight(url) {
        const path = this.$route.path;
        const menuPath = this.$route.meta.menuPath;
        return (path && path === url) ||
               (menuPath && menuPath === url);
      }
    }
  }
</script>

<style type="text/css">
  .two-depth-menu {
    color: #222222;
    font-size: 16px;
  }

  .two-depth-menu > .ico_oval_6{
    /*background-color: transparent;*/
    margin-left: -12px;
  }

  .three-depth-menu {
    color: #888888;
    font-size: 13px;
  }

  .three-depth-menu[highlight="true"] {
    color: #222222;
  }

  .two-depth-menu + .two-depth-menu {
    margin-top: 30px;
  }

  .sidebar-bg {
    background-color: #FFFFFF;
    padding-left: 30px;
    padding-top: 1.33rem;
    padding-bottom: 1.33rem;
    overflow-y: auto;
  }
</style>
